import React, { useEffect, useState } from 'react';
import { LayoutDashboard } from '../../layouts/layout-dashboard';
import { Nav } from '../../components/nav';
import { Breadcrumb } from '../../components/breadcrumb';
import { CardWorkflow } from '../../components/cardworkflow';
import { Container, Row, Col } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import { Search } from '../../components/search';
import { IconTag } from '../../assets/images/icons/icons';
import { useAxios } from '../../hooks/useAxios';
import { Preloader } from '../../components/preloader';
//import { BetaRight } from '../../components/beta-header';
import { ArchieImg, ArcosImg, ArcelImg, ArchanaImg } from '../../assets/images/images';
import { IconWf13, IconWf14, IconWf15, IconWf16, IconWf17, IconWf18, IconWf19 } from '../../assets/images/icons/icons';

const Workflows = (props) => {
  const { id } = useParams();
  const { pagename } = useParams();
  const { data, error, loading, fetchNow } = useAxios();
  const [search, setSearch] = useState(false);
  const [searching, setSearching] = useState(false);
  const [resetSearch, setResetSearch] = useState(false);

  let searchURL = `/api/platform/searchWorkflowTemplate`;
  let getAllURL = `/api/platform/solution/${id}/`;

  let timeOutId = null;
  const [solutionWorkflows, setSolutionWorkflows] = useState({
    name: null,
    descrption: null,
    workflows: [],
  });

  const [filterText, setFilterText] = useState('');

  useEffect(() => {
    if (loading) return;

    if (filterText === '' && !data) {
      // first grab on page load
      let fetchURL = `/api/platform/solution/${id}/`;
      fetchNow(fetchURL, 'GET', null, false);
    } else if (data) {
      if (data.workflows) {
        setSolutionWorkflows(data);
      } else if (search) {
        let newSolutionsWorkflows = null;
        if (data.length === 0) {
          newSolutionsWorkflows = {
            ...solutionWorkflows,
          };
          delete newSolutionsWorkflows.workflows;
        } else {
          newSolutionsWorkflows = {
            ...solutionWorkflows,
            workflows: [...data],
          };
        }

        setSolutionWorkflows(newSolutionsWorkflows);
        setSearch(false);
      }
    }
  }, [data, fetchNow, id, loading, solutionWorkflows, filterText, search]);

  const handleSearchChange = (searchString) => {
    clearTimeout(timeOutId);
    timeOutId = setTimeout(() => {
      setSearch(true);
      setSearching(true);
      setFilterText(searchString);
    }, 700);
    if (searchString === '') setResetSearch(true);
  };

  useEffect(() => {
    if (!search) return;
    if (filterText.length > 2 && filterText !== '' && searching) {
      const payload = {
        SolutionId: id,
        Query: filterText,
      };

      fetchNow(searchURL, 'POST', payload, false);
      setSearching(false);
    } else if (resetSearch) {
      // grab all again
      fetchNow(getAllURL, 'GET', null, false);
      setResetSearch(false);
    }
  }, [filterText, fetchNow, id, getAllURL, searchURL, resetSearch, search, searching]);

  function NotFoundElement() {
    return (
      <LayoutDashboard>
        <h2>Sorry nothing matched your search</h2>
      </LayoutDashboard>
    );
  }

  if (error) {
    console.log('error', error);
    return null;
  }

  return (
    <>
      <div className="dashboard">
        <header>
          <Container fluid>
            <Row>
              <Col lg={8} className="px-5">
                <Breadcrumb label={pagename} />
                <h1>Workflows</h1>
              </Col>
              <Col lg={4} className="px-5">
                {/* <BetaRight /> */}
              </Col>
            </Row>
          </Container>
        </header>

        {solutionWorkflows ? (
          <LayoutDashboard>
            <div className="wf_ai_assistant">
              {solutionWorkflows.name === 'Finance' ? (
                <img className="assistant_thumb" src={ArchieImg} alt="Archie" />
              ) : solutionWorkflows.name === 'Operations' ? (
                <img className="assistant_thumb" src={ArcosImg} alt="Arcos" />
              ) : solutionWorkflows.name === 'Customer Experience' ? (
                <img className="assistant_thumb" src={ArcelImg} alt="Arcel" />
              ) : solutionWorkflows.name === 'Sustainability' ? (
                <img className="assistant_thumb" src={ArchanaImg} alt="Archana" />
              ) : null}
            </div>
            <Row className="flexcenter subsearch">
              <div className="subheading">
                <img className="tag" src={IconTag} alt="{solutionWorkflows.name}" />

                {solutionWorkflows.name}
              </div>
              <Search handleSearchInput={handleSearchChange} />
              {loading ? <Preloader /> : null}
            </Row>
            <Row>
              {solutionWorkflows.workflows ? (
                solutionWorkflows.workflows
                  ?.sort((a) => (a.icon === 'coming_soon' ? 1 : -1))
                  .map((solutionWorkflow) => {
                    const coming_soon = solutionWorkflow.icon === 'coming_soon' ? true : false;
                    const solutionName = solutionWorkflow.name;
                    return (
                      <Col lg={6} xl={4} xxl={4} key={solutionWorkflow.id} className="flex">
                        <CardWorkflow
                          icon={
                            solutionName === 'Invoice Data Extraction'
                              ? IconWf13
                              : solutionName === 'Document Data Extraction'
                              ? IconWf14
                              : solutionName === 'Expense Receipt Data Extraction'
                              ? IconWf15
                              : solutionName === 'Document Data Extraction'
                              ? IconWf16
                              : solutionName === 'Expense Categorisation'
                              ? IconWf16
                              : solutionName === 'Intelligent Search'
                              ? IconWf17
                              : solutionName === 'Emotion Analysis from Text Files'
                              ? IconWf18
                              : solutionName === 'Emotion Analysis from Audio/Video'
                              ? IconWf19
                              : IconWf13
                          }
                          title={solutionWorkflow.name}
                          content={solutionWorkflow.descrption}
                          id={solutionWorkflow.id}
                          coming_soon={coming_soon}
                        />
                      </Col>
                    );
                  })
              ) : (
                <NotFoundElement />
              )}
            </Row>
          </LayoutDashboard>
        ) : null}
        <Nav nav1on="on" nav2on="" nav3on="" {...props} />
      </div>
    </>
  );
};

export { Workflows };
